// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NXeh","left":"styles_left__3w8ZI"};